<template>
  <div class="createPlayStep">
    <div class="backBox">
      <img
        class="pointer"
        @click="clickLocalStep()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep">
        <div class="card-point tipBg">
          <div class="card-rule">官方规则：</div>
          <template>
            <div class="card-connet">
              <p>1、订单完成后发放奖励。</p>
            </div>
          </template>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          class="backgroundForm"
          ref="ruleForm"
          label-width="130px"
        >
          <div class="newsInfo">基本信息</div>
          <template>
            <el-form-item label="活动名称:" required>
              <el-input
                v-model="ruleForm.activityName"
                maxlength="50"
                show-word-limit
                placeholder="请输入活动名称"
                style="width: 340px"
              ></el-input>
            </el-form-item>

            <el-form-item label="活动时间:" required>
              <div class="my_select_time">
                <el-date-picker
                  v-model="activityTimeValue"
                  type="datetimerange"
                  class="rangeTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  ref="timeBox"
                  @change="activityTimeChange"
                  style="width: 340px; font-size: 12px"
                  :picker-options="pickerOptionsValue"
                  :default-time="defaultTime"
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="activityTimeValue = []"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
              <span class="lastTime" style="color: #666">
                活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天
                <span style="color: #2670fb">{{ timeOut }}</span> 小时
                <el-tooltip
                  class="item"
                  effect="light"
                  content="活动有效期不可超过订购有效期"
                  placement="bottom"
                >
                  <el-button type="text" style="width: 35px">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </span>
            </el-form-item>
            <el-form-item label="活动对象：" required>
              <el-radio-group
                v-model="ruleForm.activityObject"
                :disabled="isStartEdit"
                @change="handleActivityObj"
                style="margin-right: 16px"
              >
                <el-radio :label="0">不限</el-radio>
                <el-radio :label="1">指定身份</el-radio>
                <el-radio :label="2" disabled>指定人群</el-radio>
              </el-radio-group>
              <el-popover
                placement="right-start"
                trigger="hover"
                content="您不满足使用该功能的条件，请联系专属客服了解~"
              >
                <el-button slot="reference" disabled>{{
                  peopleList.length == 0
                    ? "选择人群"
                    : `已选${peopleList.length}个`
                }}</el-button>
              </el-popover>
            </el-form-item>
            <el-form-item
              label="新老客户："
              required
              v-if="ruleForm.activityObject == '1'"
            >
              <el-radio-group
                v-model="ruleForm.newOldCustomer"
                :disabled="isStartEdit"
              >
                <el-radio :label="0">不限</el-radio>
                <el-radio :label="1">新客</el-radio>
                <el-radio :label="2">老客</el-radio>
              </el-radio-group>
              <el-tooltip effect="dark" placement="top-start">
                <div slot="content">
                  1、历史订单中已完成订单的订单数为0则定义为新客<br />2、历史订单中已完成订单的订单数≥1则定义为新客
                </div>
                <div
                  class="cursorPointer"
                  style="
                    display: inline-block;
                    margin-left: 16px;
                    font-size: 12px;
                    color: #999;
                  "
                >
                  <span>新老客说明</span>
                  <i class="el-icon-question"></i>
                </div>
              </el-tooltip>
            </el-form-item>
            <el-form-item
              label="参与对象:"
              prop="partner"
              v-if="ruleForm.activityObject == '1'"
            >
              <el-checkbox-group
                v-model="ruleForm.partner"
                @change="checkListchange"
                :disabled="isStartEdit"
              >
                <el-checkbox label="-1" name="partner">全部</el-checkbox>
                <el-checkbox
                  label="0"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >非会员</el-checkbox
                >

                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="index + 1 + ''"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>

            <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="nowType == 'look' || (nowType == 'edit' && activityData.status == 2)"
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>

            <el-form-item label="活动条件:">
              <el-checkbox
                label="关注后方可参与活动"
                v-model="ruleForm.condFollow"
                :disabled="isStartEdit"
              ></el-checkbox>
            </el-form-item>
          </template>

          <div class="newsInfo">阶梯与奖品设置</div>
          <template>
            <el-form-item label="阶梯与奖品设置:" required>
              <span class="memberTips"
                >至多添加8个阶梯，每一个阶梯的累计金额必须大于上一阶梯。</span
              >
              <div class="rule_box_middle">
                <el-form-item label="下单时间:" required>
                  <div class="my_select_time">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleForm.orderStartTime"
                      type="datetime"
                      placeholder="开始日期"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 190px; font-size: 12px"
                      default-time="00:00:00"
                      class="time1"
                      @change="orderChange"
                      :clearable="false"
                      :disabled="isStartEdit"
                      :picker-options="pickerOrderStart"
                    >
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleForm.orderEndTime"
                      type="datetime"
                      placeholder="结束日期"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 195px; font-size: 12px"
                      default-time="23:59:59"
                      class="time2"
                      @change="orderChange"
                      :clearable="false"
                      :disabled="isStartEdit"
                      :picker-options="pickerOrderEnd"
                    >
                    </el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      @click="clearOrderTime()"
                    ></i>
                    <img
                      src="@/assets/images/select_date.svg"
                      alt=""
                      class="date_icon2"
                    />
                  </div>
                </el-form-item>
              </div>
              <div class="rule_box_bottom zindexBox">
                <el-form-item label="指定购买商品:" required>
                  <el-radio
                    v-model="ruleForm.filterType"
                    @change="filterTypeChange"
                    label="0"
                    :disabled="isStartEdit"
                    >全部商品</el-radio
                  >
                  <el-radio
                    v-model="ruleForm.filterType"
                    @change="filterTypeChange"
                    label="1"
                    :disabled="isStartEdit"
                    >指定商品</el-radio
                  >
                  <el-button
                    :disabled="
                      ruleForm.filterType == '0' ||
                      ruleForm.filterType == '2' ||
                      isStartEdit
                    "
                    :style="{
                      width: itemListForFilter.length > 0 ? '110px' : '60px',
                    }"
                    @click="exposureProductsFiter"
                  >
                    {{
                      itemListForFilter.length != ""
                        ? "已选择" + "(" + itemListForFilter.length + "个)"
                        : "+添加"
                    }}
                  </el-button>
                  <el-radio
                    v-model="ruleForm.filterType"
                    @change="filterTypeChange"
                    label="2"
                    style="margin-left: 30px"
                    :disabled="isStartEdit"
                    >排除商品</el-radio
                  >
                  <el-button
                    :disabled="
                      ruleForm.filterType == '0' ||
                      ruleForm.filterType == '1' ||
                      isStartEdit
                    "
                    :style="{
                      width: itemListForFilter2.length > 0 ? '110px' : '60px',
                    }"
                    @click="exposureProductsFiter2"
                  >
                    {{
                      itemListForFilter2.length != ""
                        ? "已选择" + "(" + itemListForFilter2.length + "个)"
                        : "+添加"
                    }}
                  </el-button>
                  <div class="memberTips">
                    选择指定商品，用户订单中内有一件指定商品时则整笔计算
                  </div>
                  <div class="memberTips">
                    选择排除商品，用户订单中全部为排除商品时订单将不计算；用户订单内有一件非排除商品时，只算非排除商品部分。
                  </div>
                </el-form-item>
              </div>
              <div class="newCard">
                <el-tabs
                  v-model="editableTabsValue"
                  type="card"
                  editable
                  @edit="handleTabsEdit"
                  class="zindexBox"
                >
                  <el-tab-pane
                    :key="item.name"
                    v-for="(item, index) in editableTabs"
                    :label="item.title"
                    :name="item.name"
                  >
                    <div class="prize_box">
                      <el-form-item
                        label="累计金额:"
                        required
                        label-width="100px"
                      >
                        <el-input
                          v-model="item.money"
                          @input="
                            item.money = getNumberData($event, 0, 0, 9999999)
                          "
                          placeholder="请输入"
                          style="width: 200px"
                          @change="inputMoney($event, index)"
                          :disabled="isStartEdit"
                        ></el-input>
                        元
                        <div class="memberTips">
                          <div>注：</div>
                          <div>1、该订单金额为实付金额，至多输入9999999元</div>
                          <div>
                            2、设置则当用户在对应时间累计金额≥所设金额时，若对应阶梯奖品仍有库存则中奖。
                          </div>
                          <div>
                            3、各阶梯均为累计金额，若未勾选用户只能领取一次奖品的活动限制，活动设置后，假设阶梯一和阶梯二分别设置100和200，若用户消费满200时可以同时获得两个阶梯的奖品。
                          </div>
                          <div>
                            4、以收货为节点，用户需要在活动下单时间内下单，且对应订单需要是已完成状态，否则无法计入累计金额
                          </div>
                        </div>
                      </el-form-item>
                      <el-form-item
                        label="奖品设置:"
                        required
                        label-width="100px"
                      >
                        <span class="memberTips">
                          注：订单完成后发放奖励，整个活动期内每人每个阶梯只可领取1次及其中1个奖品</span
                        >
                      </el-form-item>
                      <el-table
                        :header-cell-style="{
                          'text-align': 'center',
                          'border-bottom': '2px solid #EBEEF5',
                          background: '#F8F9FF',
                        }"
                        :cell-style="{
                          'text-align': 'center',
                          overflow: 'visible',
                        }"
                        :data="item.content"
                        border
                        style="
                          width: 625px;
                          overflow: visible;
                          margin-left: 100px;
                        "
                      >
                        <el-table-column prop="date" label="序号" width="110">
                          <template slot-scope="scope">
                            <!-- <el-input @keyup.native="limitInput($event)" v-model="scope.row.peopleCount"></el-input> -->
                            <span>{{ scope.$index + 1 }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="name" label="奖品类型">
                          <template slot-scope="scope">
                            <span
                              style="color: #2670fb; cursor: pointer"
                              v-if="
                                scope.row.prizeType == 3 ||
                                scope.row.prizeType == 10
                              "
                              @click="centerVis(scope)"
                              >{{ scope.row.title }}</span
                            >
                            <span
                              style="color: #2670fb; cursor: pointer"
                              v-else-if="scope.row.prizeType"
                              @click="centerVis(scope)"
                              >{{ scope.row.prizeType | prizeType }}</span
                            >
                            <span
                              v-else
                              @click="centerVis(scope)"
                              style="color: #2670fb; cursor: pointer"
                              >选择奖品</span
                            >
                          </template>
                        </el-table-column>
                        <el-table-column prop="price" width="110" label="值">
                        </el-table-column>
                        <el-table-column width="145" label="奖品总份数">
                          <template slot-scope="scope">
                            <el-input
                              v-model="scope.row.prizeCount"
                              placeholder="请输入"
                              @blur="beAdd(scope.row)"
                              @input="
                                scope.row.prizeCount = getNumberData($event, 0)
                              "
                            ></el-input>
                            <div class="del_box">
                              <div class="delQx" @click="itemDel(scope.$index)">
                                <img src="@/assets/images/btn_del.svg" alt="" />
                              </div>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                      <div
                        @click="addPrizeRule"
                        class="add_btn1"
                        style="margin-left: 100px"
                      >
                        <!-- <img style="width:24px" src="../../assets/images/add.svg" alt="" /> -->
                        添加奖项（{{ item.content.length }}/4）
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-form-item>
            <el-form-item label="用户领取限制:">
              <el-checkbox
                label="用户只能领取一次奖品"
                v-model="ruleForm.claimRewardRule"
                :disabled="isStartEdit"
              ></el-checkbox>
              <span class="memberTips" style="margin-left: 10px"
                >注：开启该开关，用户在当前活动只能领取一次奖励。</span
              >
            </el-form-item>
          </template>

          <div class="newsInfo">曝光商品</div>
          <template>
            <el-form-item label="曝光商品:" class="zindexBox">
              <el-checkbox v-model="ruleForm.exposureSwitch">
                是否添加曝光商品
              </el-checkbox>
              <el-button
                style="width: auto; margin: 0 15px"
                @click="exposureProducts"
                :disabled="ruleForm.exposureSwitch == false"
              >
                {{
                  itemListFor.length != ""
                    ? "添加曝光商品" + "(" + itemListFor.length + "/300" + ")"
                    : "添加曝光商品"
                }}
              </el-button>
              <draggable
                v-if="itemListFor.length > 0"
                v-model="mainImagelist"
                chosen-class="chosen"
                :scroll="true"
                animation="150"
                force-fallback="true"
                @start="isDragging = true"
                @end="onEnd"
                style="
                  margin-top: 10px;
                  background: rgba(38, 112, 251, 0.06);
                  padding: 10px 10px 0px 10px;
                "
              >
                <transition-group type="transition">
                  <div
                    v-for="(item, index) in mainImagelist"
                    :key="item.skuId+index"
                    style="display: inline-block; position: relative"
                    class="show_upImg2"
                  >
                    <img
                      :src="item.logo"
                      width="120px"
                      height="120px"
                      style="display: inline-block"
                    />&nbsp;
                    <div class="delectPosible">
                      <span class="delectSort">拖动排序</span>
                      <img
                        src="@/assets/thdImg/pages/delet.svg"
                        @click.stop="delec(item, index)"
                        class="delectIcom"
                      />
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </el-form-item>
          </template>

          <div class="newsInfo">活动规则</div>
          <template>
            <el-form-item label="活动规则:" required>
              <div
                style="
                  width: 550px;
                  padding: 8px;
                  background: #f9fafb;
                  position: relative;
                "
              >
                <el-input
                  maxlength="2000"
                  type="textarea"
                  class="textarea"
                  style="width: 484px"
                  resize="none"
                  v-model="ruleForm.activityRulesText"
                  :disabled="backgroundOpacity"
                ></el-input>

                <div>
                  <el-button
                    type="primary"
                    class="generate"
                    plain
                    @click="generateRule"
                    :disabled="backgroundOpacity"
                    >生成规则</el-button
                  >
                  <span class="desc">
                    <i
                      class="el-alert__icon el-icon-info"
                      style="color: #999"
                    ></i>
                    点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示。
                  </span>
                </div>
              </div>
            </el-form-item>
          </template>

          <div
            v-if="backgroundOpacity"
            class="backgroundOpacity"
            style="height: calc(100% - 45px)"
          ></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <el-button
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <template v-if="!backgroundOpacity">
        <el-button
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
    </div>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      :typeDefault="typeDefault"
      :num="1"
      :actId="valueRow"
      :echoDate="echoDate"
      :JingdouCount="JingdouCount"
      @close="colseDialog"
      v-if="showDialog"
      ref="selectProduct"
      @choose-shop="getTheData"
      :isShowFirst="false"
    ></selectProduct>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr"
      :maxNum="300"
    >
    </selectGoodsMonitor>
    <!-- 指定购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter"
      @transferName="selectGoodsCloseFilter"
      :postForm="selectGoodsFilterArr"
      :maxNum="20"
    >
    </selectGoodsMonitor>
    <!-- 排除购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter2"
      @transferName="selectGoodsCloseFilter2"
      :postForm="selectGoodsFilterArr2"
      :maxNum="20"
    >
    </selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { searchfocusStores } from "@/api/integralCenter/integralTask";
// import selectProduct from "./select_prize&integral";
import selectProduct from "./select_product";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";

import {
  createPurchaseActivity,
  purchaseActivityDetail,
  editPurchaseActivity,
} from "@/api/paradiseAndTaskCommonController";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";

export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "淘宝E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "淘宝PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      }
      return result;
    },
  },
  data() {
    return {
      isStartEditTime: "",
      isStartEdit: false,
      valueRow: null,
      activityData: {
        id: 132,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      isCopy: false, //复制
      activeValue: null,
      backgroundOpacity: false,
      isSave: true,
      navList: [],
      tabActive: 0,
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.state.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      fromLoading: false, // 数据加载 显示

      selectGoodsStateFilter: false,
      itemListForFilter: [],
      selectGoodsFilterArr: [],

      selectGoodsStateFilter2: false,
      itemListForFilter2: [],
      selectGoodsFilterArr2: [],

      JingdouCount: {},
      prizeSettingList: {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        discount: "",
        singleAmount: "",
      },
      isShowPrizeType: false,

      levelList: [],
      disableTime: false,
      clickActual: false,
      showDialog: false,
      momentValue: {}, //编辑回显
      isShow: false,

      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      activityStartTime: null,
      activityEndTime: null,
      peopleList: [],
      ruleForm: {
        membershipTime:"", // 入会时间
        //设置规则表单
        activityName: "", //活动名称
        startTime: "",
        endTime: "",
        activityStartTime: "", //活动开始时间
        activityEndTime: "", //活动结束时间
        activityRulesText: "", //生成规则
        activityObject: 0,
        newOldCustomer: 0,
        partner: ["-1"],
        condFollow: false,

        exposureSwitch: false, // 是否添加曝光商品
        itemList: [], // 曝光商品集合

        claimRewardRule: false, //用户领取限制

        orderStartTime: "", //下单开始时间
        orderEndTime: "", //下单结束时间
        filterType: "0", //过滤商品：0全部商品 1指定商品 2排除商品
      },
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          price: "",
          prizeCount: "",
          singleAmount: "",

          name: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        questionDescription: [
          { required: true, message: "请填写调查问卷主题", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        prizeSettingList: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
      },
      generalCoupon: {
        // 通用优惠券
        couponType: 0,
      },
      //下单时间限制
      pickerOrderEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.orderStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.orderStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.orderStartTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.orderStartTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOrderStart: {
        disabledDate: (time) => {
          if (this.ruleForm.orderEndTime) {
            return (
              time.getTime() > new Date(this.ruleForm.orderEndTime).getTime()
            );
          } else {
          }
        },
      },

      //奖品设置
      editableTabsValue: "1",
      editableTabs: [
        {
          title: "阶梯1",
          name: "1",
          money: "",
          content: [
            {
              name: "",
              price: "",
              prizeCount: "",
            },
          ],
        },
        {
          title: "阶梯2",
          name: "2",
          money: "",
          content: [
            {
              name: "",
              price: "",
              prizeCount: "",
            },
          ],
        },
      ],
      copyEditableTabs: [],
      tabIndex: 2,
    };
  },
  async created() {
    this.activityData = this.$route.query.activityData;
    this.queItem = this.questionForm;
    if (this.$route.query.valueRow) {
      this.backgroundOpacity =
        this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.statusComment =
        this.$route.query.statusComment == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.activeValue = this.$route.query.activeValue;
      this.typeDetail();
      // this.backgroundOpacity = this.$route.query.backgroundOpacity
    } else if (this.$route.query.copyParams) {
      // 复制
      this.isCopy = true;
      this.backgroundOpacity = false;
      this.isSave = true;
      this.isStartEdit = false;
      this.statusComment = true;
      this.valueRow = this.$route.query.copyParams.valueRow;
      this.activeValue = this.$route.query.copyParams.activeValue;
      this.typeDetail();
    } else {
      this.activityTimeChange();
    }
  },
  mounted() {
    this.getLevel();
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
  },
  methods: {
    //回显
    typeDetail() {
      //关注店铺有礼
      purchaseActivityDetail(this.valueRow.id)
        .then((res) => {
          console.log("活动信息123------>", res.data);
          let datas, change1, change2, days, daysStart, daysEnd, date3;
          daysStart = res.data.startTime.substring(0, 10);
          daysEnd = res.data.endTime.substring(0, 10);
          datas = daysEnd.split("-");
          change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          datas = daysStart.split("-");
          change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
          this.timeDay = days;
          //计算小时
          date3 =
            new Date(res.data.endTime).getTime() -
            new Date(res.data.startTime).getTime();
          let leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
          this.activityTimeValue = [
            String(res.data.startTime),
            String(res.data.endTime),
          ];

          if (this.isStartEdit) {
            //进行中活动 无法修改活动开启时间
            this.isStartEditTime = String(res.data.startTime);
          }
          this.ruleForm.membershipTime = res.data.membershipTime
          this.ruleForm.activityName = res.data.activityName;
          this.ruleForm.activityStartTime = String(res.data.startTime);
          this.ruleForm.activityEndTime = String(res.data.endTime);
          this.ruleForm.activityRulesText = this.isCopy
            ? ""
            : String(res.data.ruleDescription); //生成规则
          this.ruleForm.condFollow = Boolean(res.data.ruleDto.condFollow);
          this.ruleForm.activityObject = res.data.hasOwnProperty(
            "activityObject"
          )
            ? res.data.activityObject
            : 0;
          this.ruleForm.newOldCustomer = res.data.hasOwnProperty(
            "newOldCustomer"
          )
            ? Number(res.data.newOldCustomer)
            : 0;
          this.peopleList =
            res.data.hasOwnProperty("seniorGroupId") &&
            res.data.seniorGroupId.length > 0
              ? res.data.seniorGroupId.split(",")
              : [];
          if (res.data.allowLevel) {
            this.ruleForm.partner = res.data.allowLevel.split(",");
          }

          this.ruleForm.orderStartTime = res.data.ruleDto.orderStartTime;
          this.ruleForm.orderEndTime = res.data.ruleDto.orderEndTime;

          this.ruleForm.claimRewardRule = res.data.ruleDto.claimRewardRule;

          this.ruleForm.filterType = String(res.data.ruleDto.filterType);

          // 指定购买商品
          if (res.data.ruleDto.filterType == 1) {
            this.itemListForFilter = res.data.ruleDto.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            });
            this.selectGoodsFilterArr = this.itemListForFilter;
          }

          // 指定购买商品
          if (res.data.ruleDto.filterType == 2) {
            this.itemListForFilter2 = res.data.ruleDto.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            });
            this.selectGoodsFilterArr2 = this.itemListForFilter2;
          }

          // 阶梯回显---start
          if (!this.isCopy) {
            let stagePrizeMapBack = Object.values(
              res.data.ruleDto.stagePrizeMap
            );
            console.log("stagePrizeMapBack", stagePrizeMapBack);
            this.editableTabs = stagePrizeMapBack.map((item, index) => {
              let prizeobj = {
                title: "阶梯" + Number(index + 1),
                name: String(Number(index + 1)),
                money: item.orderAmtLimit,
                content: [],
              };
              prizeobj.content = item.prizeDTOS.map((item, index) => {
                console.log("item", item);
                let prize = {
                  pointPrizeId: item.pointPrizeId ? item.pointPrizeId : "",
                  title: item.title,
                  assetsId: item.assetsId,
                  prizeType: item.prizeType,
                  singleAmount: item.singleAmount, //
                  totalAmount: item.prizeCount, // 总数额
                  prizeCount: item.totalAmount,
                  price: item.price,
                  minNum: item.totalAmount,
                };
                if (prize.prizeType == 3 || prize.prizeType == 10) {
                  prize.logo = item.logo;
                }
                if (prize.prizeType == 1) {
                  prize.quota = item.quota;
                  prize.couponType = item.couponType;
                  if (item.couponType == 4) {
                    prize.batchKey = item.batchKey;
                  }
                }
                if (prize.prizeType == 3) {
                  prize.prizeRemarkType = item.prizeRemarkType;
                  if (item.prizeRemarkType == 1){
                    prize.pointActivityPrizeRemark = item.pointActivityPrizeRemark
                  }
                }
                return prize;
              });
              return prizeobj;
            });
          } else {
            this.editableTabs = [
              {
                title: "阶梯1",
                name: "1",
                money: "",
                content: [
                  {
                    name: "",
                    price: "",
                    prizeCount: "",
                  },
                ],
              },
              {
                title: "阶梯2",
                name: "2",
                money: "",
                content: [
                  {
                    name: "",
                    price: "",
                    prizeCount: "",
                  },
                ],
              },
            ];
          }
          //---end

          //曝光商品
          this.ruleForm.exposureSwitch =
            res.data.isExposureItem == 0 ? false : true;
          console.log(this.ruleForm.exposureSwitch);
          // 商品处理
          let shopList = res.data.itemList
            ? res.data.itemList.map((item) => {
                return {
                  ...item,
                  numIid: item.wareId,
                  itemTitle: item.title,
                  picUrl: item.logo,
                };
              })
            : [];
          this.selectGoodsArr = shopList;
          this.itemListFor = shopList;
          this.mainImagelist = shopList;
          this.itemListFor = shopList;

          this.activityTimeChange();
        })
        .catch(() => {});
    },

    colseDialog() {
      this.showDialog = false;
      this.clickActual = false;
    },

    //阶梯卡片设置
    handleTabsEdit(targetName, action) {
      if (this.isStartEdit) return;
      if (this.backgroundOpacity || this.activityData.isStart) {
        return;
      }
      if (action === "add") {
        if (this.editableTabs.length < 8) {
          console.log("this.editableTabs", this.editableTabs);
          let newTabName = ++this.tabIndex + "";
          this.editableTabs.push({
            title: "阶梯" + Number(this.editableTabs.length + 1),
            name: newTabName,
            money: "",
            content: [
              {
                peopleCount: "",
                prizeType: "",
                discount: "",
                prizeCount: "",
                singleAmount: "",
              },
            ],
          });
          this.editableTabsValue = newTabName;
        } else {
          this.$message.warning("至多添加8个阶梯");
        }
      }
      if (action === "remove") {
        if (this.editableTabs.length > 1) {
          let tabs = this.editableTabs;
          let activeName = this.editableTabsValue;
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }

          this.editableTabsValue = activeName;
          this.editableTabs = tabs.filter((tab) => tab.name !== targetName);

          this.editableTabs.forEach((item, index) => {
            item.title = "阶梯" + Number(index + 1);
          });
        } else {
          this.$message.warning("阶梯设置需≥1");
        }
      }
    },

    //清空商品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
      this.tableData = [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          price: "",
          prizeCount: "",
          singleAmount: "",
        },
      ];
      this.isShowPrizeType = false;
    },

    //选择奖品弹窗
    centerVis(scope) {
      if (this.isStartEdit) return;
      // this.itemArr = this.tableData
      this.editableTabs.forEach((item) => {
        console.log("(item.name", item.name, this.editableTabsValue);
        if (item.name == this.editableTabsValue) {
          this.itemArr = item.content;
        }
      });
      console.log("this.itemArr", this.itemArr);
      this.tableIndex = scope.$index;
      this.JingdouCount.prizeCount = scope.row.prizeCount;
      if (this.itemArr[scope.$index].prizeType == 3) {
        this.clickActual = true;
      }
      this.echoDate = scope.row;
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
        this.$refs.selectProduct.physicalGift(this.echoDate)
      });
    },
    //选择奖品数据
    getTheData(data, prizeType) {
      console.log(data, prizeType, "data");
      this.prizeSettingList = {};
      if (data.couponType == 4) {
        this.generalCoupon = JSON.parse(JSON.stringify(data));
      } else {
        this.generalCoupon = { couponType: 0 };
      }
      this.showDialog = false;

      if (data.couponType == 4) {
        if (!data.price || !data.batchKey || !data.couponType) {
          this.$message.warning("请填写完整的优惠券信息");
          return;
        }
        this.prizeSettingList.singleAmount = 1;
        this.prizeSettingList.assetsId = null;
        this.prizeSettingList.prizeType = prizeType;
        this.prizeSettingList.title = "优惠券";
        this.prizeSettingList.price = data.price;
        this.prizeSettingList.batchKey = data.batchKey;
        this.prizeSettingList.couponType = data.couponType;
      } else {
        this.prizeSettingList.singleAmount = Number(data.price) || 1;
        this.prizeSettingList.assetsId = Number(data.couponId);
        this.prizeSettingList.prizeType = prizeType;
        this.prizeSettingList.logo = data.logo;
        this.prizeSettingList.title = data.name || prizeType;
        this.prizeSettingList.price = data.discount || data.price;
      }
      if (prizeType == 1) {
        if (data.couponType == 4) {
          this.prizeSettingList.couponType = 4;
        } else {
          this.prizeSettingList.couponType = 3;
        }
      }
      if (prizeType == 4) {
        if (!data.discount) {
          this.$message.warning("店铺积分不能为空");
          return;
        }
        this.prizeSettingList.title = data.discount + "店铺积分";
        this.prizeSettingList.price = data.discount;
        this.prizeSettingList.singleAmount = data.singleAmount;
      } else if (prizeType == 2) {
        this.prizeSettingList.singleAmount = data.singleAmount;
        this.prizeSettingList.couponType = data.couponType;
        this.prizeSettingList.title = prizeType;
        this.prizeSettingList.quantityTotal = data.quantityTotal;
      } else if (prizeType == 10) {
        this.prizeSettingList.singleAmount = data.singleAmount;
        this.prizeSettingList.couponType = data.couponType;
        this.prizeSettingList.title = data.itemTitle;
        this.prizeSettingList.quantityTotal = data.quantityTotal;
        this.prizeSettingList.assetsId = data.id;
        this.prizeSettingList.logo = data.picUrl;
      }
      this.getTheData2(data, prizeType);
      this.setPrizeTxt(this.prizeSettingList);
    },
    //选择商品数据 曝光
    getTheData2(data, prizeType) {
      this.editableTabs.forEach((item) => {
        if (item.name == this.editableTabsValue) {
          item.content[this.tableIndex].prizeType = prizeType;
          item.content[this.tableIndex].price =
            data.discount || data.singleAmount;
          item.content[this.tableIndex].singleAmount = data.singleAmount;
          item.content[this.tableIndex].title = data.name || prizeType;
          item.content[this.tableIndex].assetsId = Number(data.couponId);
          item.content[this.tableIndex].logo = data.logo;
          if (prizeType == 1) {
            item.content[this.tableIndex].quota = data.quota;
            item.content[this.tableIndex].couponType = data.couponType;
            if (data.couponType == 4) {
              item.content[this.tableIndex].prizeType = prizeType;
              item.content[this.tableIndex].price = data.price;
              item.content[this.tableIndex].singleAmount = data.singleAmount;
              item.content[this.tableIndex].price = data.price;
              item.content[this.tableIndex].assetsId = null;
              item.content[this.tableIndex].batchKey = data.batchKey;
            }
          }
          if (prizeType == 2) {
            item.content[this.tableIndex].quantityTotal = data.quantityTotal;
          }
          if (prizeType == 3) {
            item.content[this.tableIndex].prizeRemarkType = data.prizeRemarkType;
            // 开启备注
            if (data.prizeRemarkType == 1){
              const pointActivityPrizeRemark = {}
              pointActivityPrizeRemark.receivePayment = data.receivePayment;
              pointActivityPrizeRemark.remarkActionType = data.remarkActionType;
              if(data.remarkActionType == '1'){
                pointActivityPrizeRemark.startCreateTradeTimeForManualLinkTrade = data.startCreateTradeTimeForManualLinkTrade;
                pointActivityPrizeRemark.endCreateTradeTimeForManualLinkTrade = data.endCreateTradeTimeForManualLinkTrade;
              }else{
                pointActivityPrizeRemark.tradeLimitTime = data.tradeLimitTime;
                pointActivityPrizeRemark.tradeLimitTimeUnit = data.tradeLimitTimeUnit;
              }
              pointActivityPrizeRemark.itemType = data.itemType;
              pointActivityPrizeRemark.tradeFlag = data.tradeFlag;
              pointActivityPrizeRemark.content = data.content;

              if (data.itemType) {
                const arr = data.goodsList.map(item => item.wareId || item.numIid)
                pointActivityPrizeRemark.numIid = arr.join(",");
              } else {
                pointActivityPrizeRemark.numIid = "";
              }
              item.content[this.tableIndex].pointActivityPrizeRemark = pointActivityPrizeRemark
            }
          }
          if (prizeType == 10) {
            item.content[this.tableIndex].price = data.price;
            item.content[this.tableIndex].assetsId = data.id;
            item.content[this.tableIndex].logo = data.picUrl;
            item.content[this.tableIndex].title = data.itemTitle;
          }
        }
      });
    },
    setPrizeTxt(item) {
      if (item.prizeType == 8) {
        item.prizeTxt = item.price + "元";
      } else if (
        item.prizeType == 7 ||
        item.prizeType == 6 ||
        item.prizeType == 5
      ) {
        item.prizeTxt = item.price;
      } else {
        if (item.couponType == 4) {
          item.prizeTxt = item.price;
        } else {
          item.prizeTxt = item.singleAmount;
        }
      }
      if (this.prizeSettingList.prizeType) {
        this.isShowPrizeType = true;
      }
    },

    // 弹框确认
    handleDialogCloseAnoth() {
      this.ruleForm.startTime = this.activityTimeValue[0];
      this.ruleForm.endTime = this.activityTimeValue[1];

      //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }

      //下单时间不能为空
      if (!this.ruleForm.orderStartTime || !this.ruleForm.orderEndTime) {
        this.$message.warning("请填写下单时间！");
        return;
      }

      if (this.ruleForm.filterType == 1) {
        if (this.itemListForFilter.length == 0) {
          this.$message.warning("请添加指定商品！");
          return;
        }
      }
      if (this.ruleForm.filterType == 2) {
        if (this.itemListForFilter2.length == 0) {
          this.$message.warning("请添加排除商品！");
          return;
        }
      }

      // 请将累计金额填写完整！
      let isMoney = false;
      let moneyIndex = 0;
      this.editableTabs.map((item, index) => {
        if (!item.money) {
          isMoney = true;
          moneyIndex = Number(index) + 1;
        }
      });
      if (isMoney) {
        return this.$message.warning(
          "请填写阶段" + moneyIndex + "的累计金额！"
        );
      }

      // 请将奖品填写完整！
      let isFlay = false;
      this.editableTabs.map((item, index) => {
        item.content.forEach((item) => {
          if (!item.price || !item.prizeCount) {
            isFlay = true;
          }
        });
      });
      if (isFlay) {
        return this.$message.warning("请将奖品填写完整！");
      }

      let _itemList = [];
      //请添加曝光商品！
      if (this.ruleForm.exposureSwitch) {
        console.log("this.mainImagelist", this.mainImagelist);
        if (this.mainImagelist) {
          if (this.mainImagelist.length === 0) {
            this.$message.warning("请添加曝光商品！");
            return;
          } else {
            _itemList = this.mainImagelist.map((item) => {
              return {
                logo: item.logo,
                price: item.price,
                title: item.title,
                skuId: item.skuId,
                wareId: item.numIid,
              };
            });
          }
        } else {
          this.$message.warning("请添加曝光商品！");
          return;
        }
      }

      if (!this.ruleForm.activityRulesText) {
        this.$message.warning("活动规则不能为空");
        return;
      }

      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        let {
          activityName,
          startTime,
          endTime,
          activityRulesText,
          exposureSwitch,
          prizeCount,
          condFollow,
        } = this.ruleForm;
        let obj = {
          activityName: activityName,
          startTime: startTime,
          endTime: endTime,
          ruleDescription: activityRulesText,
          isExposureItem: exposureSwitch ? 1 : 0,
          activityObject: this.ruleForm.activityObject,
          membershipTime:this.ruleForm.membershipTime,
          newOldCustomer: this.ruleForm.newOldCustomer,
          seniorGroupId: this.peopleList.join(","),
          allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
          points: 1, //跟下单有礼同步
          ruleDTO: {
            days: 100, //跟下单有礼同步
            subType: 34,
            orderStartTime: this.ruleForm.orderStartTime,
            orderEndTime: this.ruleForm.orderEndTime,
            orderCountType: 1, //满额有礼固定传1，梯度奖品累计(1)/单笔(0)
            prizeRule: 2, //发放奖品规则类型 0统一奖品 1梯度奖品 2多梯度奖品, 满额有礼传2
            condFollow: Number(condFollow),
            claimRewardRule: this.ruleForm.claimRewardRule, //用户奖品领取限制
            filterType: this.ruleForm.filterType,
            skuIdList:
              this.ruleForm.filterType == 2
                ? this.itemListForFilter2.map((item) => {
                    return {
                      logo: item.logo,
                      jdPrice: item.price,
                      skuName: item.title,
                      skuId: item.skuId,
                      wareId: item.numIid,
                    };
                  })
                : this.itemListForFilter.map((item) => {
                    return {
                      logo: item.logo,
                      jdPrice: item.price,
                      skuName: item.title,
                      skuId: item.skuId,
                      wareId: item.numIid,
                    };
                  }),
          },
          pointActivityPrizeDTOList: this.tableData.map((item) => {
            let prize = {
              title: item.title,
              assetsId: item.assetsId,
              prizeType: item.prizeType,
              singleAmount: item.singleAmount, //
              totalAmount: prizeCount, // 总数额
              price: item.price,
            };
            if (prize.prizeType == 3 || prize.prizeType == 10) {
              prize.logo = item.logo;
            }
            if (prize.prizeType == 1) {
              prize.quota = item.quota;
              prize.couponType = item.couponType;
              if (item.couponType == 4) {
                prize.batchKey = item.batchKey;
              }
            }
            return prize;
          }),
          itemList: _itemList,
        };

        //处理阶梯 --- start
        let stagePrizeMap = this.editableTabs.map((item, index) => {
          let prizeList = {
            orderAmtLimit: item.money,
            prizeDTOS: [],
          };
          prizeList.prizeDTOS = item.content.map((item) => {
            let prize = {
              pointPrizeId: item.pointPrizeId,
              title: item.title,
              assetsId: item.assetsId,
              prizeType: item.prizeType,
              singleAmount: item.singleAmount, //
              totalAmount: item.prizeCount, // 总数额
              price: item.price,
            };
            if (prize.prizeType == 3 || prize.prizeType == 10) {
              prize.logo = item.logo;
            }
            if (prize.prizeType == 1) {
              prize.quota = item.quota;
              prize.couponType = item.couponType;
              if (item.couponType == 4) {
                prize.batchKey = item.batchKey;
              }
            }
            if (prize.prizeType == 3) {
              prize.prizeRemarkType = item.prizeRemarkType;
              if (item.prizeRemarkType == 1){
                prize.pointActivityPrizeRemark = item.pointActivityPrizeRemark
              }
            }
            return prize;
          });
          return prizeList;
        });

        obj.ruleDTO.stagePrizeMap = this.convertArrayToObject(stagePrizeMap);
        // --end

        if (this.valueRow && !this.isCopy) {
          console.log("保存修改");
          editPurchaseActivity({
            ...obj,
            pointActivityId: this.valueRow.id,
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              this.$router.push({ path: "activeList1" });
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log(
            "this.activityData.templateId",
            this.activityData.templateId
          );
          obj.templateId = this.activityData.templateId;
          createPurchaseActivity(obj).then((res) => {
            console.log("res", res);
            if (res.code == 1) {
              this.$message.success(res.message);
              this.$router.push({ path: "activeList1" });
            } else {
              this.$message.error(res.message);
            }
          });
        }
        this.joinBlackList = false;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },

    //应懒后端要求转换格式
    convertArrayToObject(arr) {
      const result = {};
      arr.forEach((item, index) => {
        result[index + 1] = item;
      });
      return result;
    },

    //删除
    delec(item, index) {
      let i = -1;
      this.mainImagelist.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      console.log(i, 55555);
      if (i != -1) {
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist;
      }
      console.log(this.mainImagelist, 4444444);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      console.log("this.mainImagelist)", this.mainImagelist);
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
      console.log("this.mainImagelist)", arr);
    },

    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log(res, 6667);
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          console.log(this.levelList, 111112);
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },

    //判断输入的阶梯金额大小
    inputMoney(e, index) {
      console.log(e, index);
      for (let i = 0; i < index; i++) {
        console.log(this.editableTabs[i]);
        if (Number(e) <= Number(this.editableTabs[i].money)) {
          this.editableTabs[index].money = "";
          this.$message.warning(
            "阶梯" + (index + 1) + "的累计金额需设置大于上一阶梯的累计金额"
          );
          return;
        }
      }
      for (let j = this.editableTabs.length - 1; j > index; j--) {
        if (
          Number(this.editableTabs[j].money) &&
          Number(e) >= Number(this.editableTabs[j].money)
        ) {
          this.editableTabs[index].money = "";
          this.$message.warning(
            "阶梯" + (index + 1) + "的累计金额需设置小于下一阶梯的累计金额"
          );
          return;
        }
      }
    },

    filterTypeChange(val) {
      if (val == "0") {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
        this.itemListForFilter2 = [];
        this.selectGoodsFilterArr2 = [];
      }
    },
    //指定购买商品商品弹窗
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      // console.log(this.itemListFor);
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
        // this.mainImagelist = [];
      }
      console.log(this.selectGoodsFilterArr, this.itemListForFilter);
      // this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    //排除购买商品商品弹窗
    exposureProductsFiter2() {
      this.selectGoodsStateFilter2 = true;
      // console.log(this.itemListFor);
      if (this.itemListForFilter2.length == 0) {
        this.itemListForFilter2 = [];
        this.selectGoodsFilterArr2 = [];
        // this.mainImagelist = [];
      }
      console.log(this.selectGoodsFilterArr2, this.itemListForFilter2);
      // this.$refs.selectGoFilter2.handleRightCurrentChange(1);
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsStateFilter = false;
        return;
      }
    },

    // 活动进行中修改奖品数量
    beAdd(row) {
      console.log("活动进行中修改奖品数量", row);
      if (this.isStartEdit) {
        if (row.minNum && Number(row.prizeCount) < Number(row.minNum)) {
          row.prizeCount = row.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },

    // 下单时间
    orderChange() {
      let start = new Date(this.ruleForm.orderStartTime).valueOf();
      let end = new Date(this.ruleForm.orderEndTime).valueOf();
      let activityEnd = new Date(this.activityTimeValue[1]).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart =
        this.ruleForm.orderStartTime &&
        this.ruleForm.orderStartTime.substring(0, 10);
      daysEnd =
        this.ruleForm.orderEndTime &&
        this.ruleForm.orderEndTime.substring(0, 10);
      if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        if (days > 365) {
          this.$message.warning("下单时间最大范围为近1年");
          this.ruleForm.orderEndTime = null;
          return;
        }
      }
      if (start && end && start > end) {
        this.$message.warning("下单开始时间不能大于下单结束时间");
        this.ruleForm.orderEndTime = null;
        return;
      }
      if (activityEnd && end && end > activityEnd) {
        this.$message.warning("下单开始时间不能大于活动结束时间");
        this.ruleForm.orderEndTime = null;
        return;
      }
    },

    //活动时间驱动
    activityTimeChange(val) {
      if (this.isStartEdit) {
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0] = this.isStartEditTime;
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(
        this.$store.state.loginUserInfo.expiredIn
      ).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
      if (
        this.ruleForm.activityEndTime != "" &&
        this.ruleForm.activityStartTime != ""
      ) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        if (days < 3 && !this.backgroundOpacity) {
          this.$message.warning("活动间隔最少为3天！");
          this.activityTimeValue[1] = "";
          this.ruleForm.activityEndTime = null;
          this.timeOut = 0;
          this.timeDay = 0;
          return;
        }

        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.activeValue) {
          this.disableTime = true;
        } else {
          if (!this.isStartEdit) {
            this.$message.warning("活动时间开始时间要大于当前时间的5分钟");
          }
        }
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
      }
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },

    // 下一步
    saveEdit() {
      this.$refs.ruleForm.validate((valid) => {
        console.log("进来验证");
        if (valid) {
          this.joinBlackList = true;
        } else {
          this.$message.warning("请选择活动参与对象");
          console.log("error submit!!");
          return false;
        }
      });
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      // this.$refs.selectGo.handleRightCurrentChange(1);
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsState = false;
        return;
      }
    },
    selectGoodsClose(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        // event.forEach((item) => {
        //   newArr.push(item.numIid);
        // });
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      this.selectGoodsState = false;
    },
    //选择商品数据
    selectGoodsCloseFilter(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;

        if (index && index == 1) {
          this.itemListForFilter = newArr;
          // this.mainImagelist = newArr;
          this.selectGoodsFilterArr = newArr;
        }
      }
      this.selectGoodsStateFilter = false;
    },
    //选择商品数据
    selectGoodsCloseFilter2(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;

        if (index && index == 1) {
          this.itemListForFilter2 = newArr;
          // this.mainImagelist = newArr;
          this.selectGoodsFilterArr2 = newArr;
        }
      }
      this.selectGoodsStateFilter2 = false;
    },

    itemDel(index) {
      if (this.isStartEdit) return;
      this.editableTabs.forEach((item) => {
        if (item.name == this.editableTabsValue) {
          if (item.content.length == 1) {
            this.$message.warning("必须有一个阶梯");
            return;
          }
          item.content.splice(index, 1);
        }
      });
    },
    addPrizeRule() {
      if (this.isStartEdit) return;
      this.editableTabs.forEach((item) => {
        if (item.name == this.editableTabsValue) {
          if (item.content.length === 4) {
            this.$message.warning("最多可设置4个奖项");
            return;
          }
          item.content.push({
            name: "",
            price: "",
            prizeCount: "",
          });
        }
      });
    },

    //生成规则
    generateRule() {
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "";
      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动时间
      this.ruleForm.startTime = this.activityTimeValue[0];
      this.ruleForm.endTime = this.activityTimeValue[1];
      if (this.ruleForm.startTime && this.ruleForm.endTime) {
        text2 =
          "活动时间：" +
          this.ruleForm.startTime +
          "-" +
          this.ruleForm.endTime +
          "（奖品发完，活动将会提前结束）";
      }
      //参与对象
      if (this.ruleForm.partner.length > 0) {
        let levelText = [];
        this.ruleForm.partner.forEach((item, index) => {
          if (item == -1) {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              if (index + 1 == item) {
                item = it;
              }
            });
          }
          levelText.push(item);
        });

        text3 = "活动参与对象：" + levelText.splice(",");
      }
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }
      // if (this.ruleForm.condFollow == true) {
      //   text4 = "活动条件：关注店铺后方可参加活动";
      // }
      if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
        text4 =
          "参与规则：下单时间：" +
          this.ruleForm.orderStartTime +
          "-" +
          this.ruleForm.orderEndTime +
          "\n";
      }

      //奖品设置

      let text9 = "活动奖品：" + "\n";

      this.editableTabs.forEach((item, num) => {
        text4 += "阶梯" + Number(num + 1) + ":";
        text4 += "累计金额：" + item.money + "元   ";
        text9 += "阶梯" + Number(num + 1) + ":";
        item.content.forEach((item, index) => {
          let result = "";
          if (item.prizeType == "1") {
            result = item.price + "元优惠券";
          } else if (item.prizeType == "2") {
            result = item.price + "京豆";
          } else if (item.prizeType == "3") {
            result = item.price + "元#" + item.title;
          } else if (item.prizeType == "4") {
            result = item.price + "店铺积分";
          } else if (item.prizeType == "5") {
            result = item.price + "元京东E卡";
          } else if (item.prizeType == "6") {
            result = item.price + "元爱奇艺会员";
          } else if (item.prizeType == "7") {
            result = item.price + "元京东PLUS会员";
          } else if (item.prizeType == "8") {
            result = item.price + "元现金红包";
          }

          // if (item.price && item.prizeCount) {
          if (index !== 0) {
            text9 += ",";
          }
          text9 += `${index + 1}) ${result}`;
          // }
        });
        text9 += "\n";
      });

      let Arr1 = [text1, text2, text3,text34, text4, text9];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + "\n";
          newNum = newNum + 1;
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    // 返回
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
    },
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.peopleList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #fe4d45;
  }
  color: #999;
}

.flex {
  display: flex;
  align-items: center;
}

/deep/.prize_box .el-table__body-wrapper {
  overflow: visible !important;
  // overflow: auto;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}

.prize_box {
  padding: 26px 21px;
  background: #fff;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 520px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
  .add_btn1 {
    cursor: pointer;
    color: #2670fb;
    border: 1px solid #2670fb;
    width: 132px;
    height: 32px;
    display: flex;
    border-radius: 4px;
    background: rgba(38, 112, 251, 0.1);
    align-items: center;
    justify-content: center;
    margin-top: 15px;
    &:hover {
      background: #2670fb;
      color: #fff;
    }
  }
}
.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  // min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: 24px;

  .secondstep {
    // min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    // margin-bottom: 29px;
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
  }
}
.box-card {
  .boxCard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .btnCard {
      color: rgb(38, 112, 251);
      padding: 0 0 0 10px;
      cursor: pointer;
      width: 50px;
    }
  }
  .cardTitle {
    font-weight: bold;
  }
  .imgItem {
    width: 80px;
    height: 80px;
    display: block;
  }
}
.theLag {
  position: relative;
  margin-top: 10px;
  height: 142px;
  width: 302px;
  .theBox {
    height: 142px;
    width: 302px;
    // border: 1px solid #999;
    background: url("../../assets/thdImg/pages/yhq.svg") no-repeat;
    border-radius: 8px;
    position: absolute;
    color: #333333;
    margin-bottom: 10px;
    .discount_sty {
      font-family: DIN;
      font-weight: bold;
      color: #2670fb;
      font-size: 20px;
      width: 120px;
      text-align: right;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
    }
    .pp {
      width: 280px;
      text-align: center;
      bottom: 0px;
      padding-top: 10px;
    }
  }
  .btnQx {
    display: none;
  }
  &:hover {
    .btnQx {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -16px 0 0 -49px;
    }
    .backgrd {
      width: 100%;
      height: 100%;
      background: #fff;
      position: absolute;
      border-radius: 8px;
      opacity: 0.7;
    }
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}
.memberTips {
  color: red;
}
.newCard {
  width: 1000px;
  margin: 20px 0 0 0;
  /deep/.el-tabs__header {
    margin: 0;
  }
  /deep/.el-tabs__content {
    border: 1px solid #d3dce6;
    border-top: 0;
  }
  /deep/.el-tabs__new-tab {
    color: #2670fb;
    border: 1px solid #2670fb;
    width: 25px;
    height: 25px;
    margin: 8px 0 0 0;
    line-height: 25px;
    font-size: 18px;
  }
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
</style>
